import { c as _c } from "react/compiler-runtime";
import Close from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { type SnackbarKey, useSnackbar } from "notistack";
import React from "react";
type SnackbarCloseButtonProps = {
  snackbarKey: SnackbarKey;
};
export const SnackbarCloseButton: React.FC<SnackbarCloseButtonProps> = t0 => {
  const $ = _c(6);
  const {
    snackbarKey
  } = t0;
  const {
    closeSnackbar
  } = useSnackbar();
  let t1;
  if ($[0] !== closeSnackbar || $[1] !== snackbarKey) {
    t1 = () => closeSnackbar(snackbarKey);
    $[0] = closeSnackbar;
    $[1] = snackbarKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Close fontSize="small" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <IconButton size="small" onClick={t1}>{t2}</IconButton>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};